import { get, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface RmaReasonsServiceResult {
    returnedValue?: any;
}
const reasonsUrl = "/api/v1/girardin/rma";

export async function getRmaReasons(): Promise<ServiceResult<RmaReasonsServiceResult>> {
    try {
        const returnedValue = await get<any>(`${reasonsUrl}/getRmaReasons`);
        return {
            result: returnedValue,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
